import { Navigate, useParams } from "react-router-dom";
import { ArticleLayout } from "@/components/ArticleLayout";
import { getStrategyArticle } from "@/content/strategyArticles";

export default function StrategyArticlePage() {
  const { slug } = useParams();
  const article = getStrategyArticle(slug);
  if (!article) return <Navigate to="/strategy" replace />;
  return <ArticleLayout article={article} />;
}